module.exports = __webpack_public_path__ + "static/media/three_quarters_back_picture.b0c82bef.png";